export const Exceptions = {
    INCORRECT_PASSWORD_EXCEPTION: "com.actimind.actitime.administration.IncorrectPasswordException",
    PASSWORD_POLICY_VIOLATED_EXCEPTION: "com.actimind.common.administration.passwords.service.PasswordPolicyViolatedException",
}



// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/constants.js